// components/discovery/GameDiscovery.jsx
import { useDiscovery } from '../../contexts/DiscoveryContext';
import { useGameDiscovery } from '../../hooks/useGameDiscovery';
import DiscoveryStats from './DiscoveryStats';
import GamesList from './GamesList';

const GameDiscovery = () => {
    const {
        settings,
        settingsTimestamp,
        setGames,
        discoveredGames,
        onDiscoveryComplete,
        isDiscoveryActive
    } = useDiscovery();

    const {
        loading,
        stats
    } = useGameDiscovery(settings, settingsTimestamp, setGames, onDiscoveryComplete);

    return (
        <div className="p-8">
            <div className="mb-6">
                <div className="flex justify-between items-center">
                    <h2 className="text-2xl font-bold">Game Discovery</h2>
                    {isDiscoveryActive && (
                        <div className="px-3 py-1 bg-blue-100 text-blue-700 rounded-lg text-sm">
                            Discovery running in background
                        </div>
                    )}
                </div>
                <DiscoveryStats stats={stats} loading={loading} />
            </div>
            <GamesList games={discoveredGames} loading={loading} />
        </div>
    );
};

export default GameDiscovery;